import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["qrCount"];
  static values = { type: String };

  connect() {
    this.qrCountTargets.forEach((target) => {
      target.style.cssText += "opacity: 0";
    });

    const params = this.hasTypeValue && this.typeValue ? { type: this.typeValue } : {};

    axios.get("/qr-count", { params }).then(({ data }) => {
      this.qrCountTargets.forEach((target) => {
        target.style.cssText += "opacity: 1";
        target.innerHTML = data;
      });
    });
  }
}